export default "__VITE_ASSET__DL5U0PhK__"